const RowSelectionType = {
    Single: 0,
    Multiple: 1
};

export default RowSelectionType;
